import React from "react";
import BasePage from "../../../UI/BasePage/BasePage";
import Aux from "../../../hoc/Aux";
import { CardSection } from "../../../UI/ContentSection/ContentSection";
import pioneerImg from "../../../assests/images/pioneerMain.png";

const PrintGallery = () => (
  <Aux>
    <BasePage
      title={"SAMPELL‘S UNIQUE PRINT DESIGN GALLERY"}
      image={pioneerImg}
      textLineOne={
        "WITH DESIGNERS AND STREET ARTISTS WE BUILD UP A PORTFOLIO OF UNIQUE"
      }
      textLineTwo={
        "PRINT DESIGNS. YOU AS WELL CAN SUBMIT A DESIGN. A JURY WILL VOTE IF YOUR"
      }
      textLineThree={"DESIGN MAKES IT INTO OUR PORTFOLIO."}
    />
    <CardSection>here will the print form</CardSection>
  </Aux>
);

export default PrintGallery;



// WEBPACK FOOTER //
// ./src/components/Pages/PrintGallery/PrintGallery.js